import { render, staticRenderFns } from "./FormPriceHeader.vue?vue&type=template&id=960345ae&"
import script from "./FormPriceHeader.vue?vue&type=script&lang=js&"
export * from "./FormPriceHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormPriceHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports